export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f8a7b079cc85eccd1b5b341cce9633221c22de8a4&name=fetchTypeahead!'